import { render, staticRenderFns } from "./MySfQuantitySelectorWrapper.vue?vue&type=template&id=263b619b&"
import script from "./MySfQuantitySelectorWrapper.vue?vue&type=script&lang=ts&"
export * from "./MySfQuantitySelectorWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports